<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="login-box">
    <div class="card card-outline card-primary">
      <div class="card-body">
        <p style="font-size: 25px" class="login-box-msg">Verificação de celular</p>

        <div class="form-group">
          <label for="celular">Celular</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <img width="60px" height="37px" src="https://rochaleiloes.com.br/dist/img/Brazil_flag_300.png" />
            </div>

            <!--
            <input
              v-model="profile.telefone_celular"
              placeholder="Celular"
              id="celular"
              type="text"
              class="form-control"
              name="celular"
              required
              autofocus
              style="border: 1px solid black; border-right: none"
            />
            -->

            <InputMask
              id="basic"
              :readonly="!editar"
              class="form-control"
              v-model="formData.telefone_celular"
              placeholder="(__)_____-____"
              mask="(99)99999-9999"
            />

            <span class="input-group-append">
              <button v-if="!editar" type="button" class="btn btn-info" @click="editarTelefone">Editar</button>
              <button v-else type="button" class="btn btn-info" style="background-color: green; border-color: green" @click="salvarTelefone">
                Salvar
              </button>
            </span>
          </div>

          <span style="color: red" v-for="error in v$.telefone_celular.$errors" :key="error.$uid">
            {{ error.$message }}
          </span>
        </div>

        <div class="form-group code-form">
          <label for="celular">Código enviado por sms</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-envelope"></i></span>
            </div>
            <input
              placeholder="Código"
              type="text"
              class="form-control"
              v-model="codigo"
              name="edit_code"
              id="edit_code"
              required
              autocomplete="codigo"
              autofocus
            />

            <span class="input-group-append">
              <button type="button" class="btn btn-info" id="confirmar" @click="validateCode">Confirmar</button>
            </span>
          </div>
        </div>
        <div class="form-group">
          <a href="#" data-toggle="modal" data-target="#contato-modal" @click="show_contato = true">Precisa de ajuda?</a>
        </div>
        <!-- REMEMBER & LOGI BTN-->
        <div class="row resend-form">
          <div class="col-12" v-if="!show_timeout">
            <label class="form-label" id="label_delay">
              Se você não recebeu o código por SMS favor clicar em reenviar que enviaremos o SMS novamente.
            </label>
          </div>
          <div class="col-12" v-if="show_timeout">
            <label class="form-label" id="label_delay">
              Se você não recebeu o código via SMS, por favor aguarde
              {{ remaining_time }}
              segundos
            </label>
          </div>
          <!-- /.col -->
          <br />
          <br />
          <div class="col-12">
            <button @click="sendSMS" :disabled="show_timeout" class="btn btn-primary btn-block">Reenviar sms</button>
          </div>
          <!-- /.col -->
        </div>

        <div class="social-auth-links text-center mt-2 mb-3"></div>

        <!--
            <p class="mb-1">
                <a href="forgot-password.html">Esqueci minha senha</a>
            </p>
           
            <p class="mb-0">
                <a href="register.html" class="text-center">Não possui conta? Cadastre-se agora</a>
            </p>
            -->
      </div>
      <!-- /.card-body -->

      <!-- /.card -->
    </div>
  </div>

  <modal-contato :user="user" v-if="show_contato" />
</template>

<script>
import sweetAlert from "./controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import { readonly } from "vue";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { required } from "./locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["profile", "sent", "user"],

  components: { Loading, InputMask },

  data() {
    return {
      isLoading: false,
      codigo: "",
      sent_date: "",
      show_timeout: false,
      show_contato: false,
      remaining_time: 60,
      editar: false,
      celular_selecionado: "",
    };
  },

  setup() {
    const formData = reactive({
      telefone_celular: "",
    });

    const rules = computed(() => {
      return {
        telefone_celular: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    let data = moment(this.profile.telefone_celular_verificacao_delay);
    let dataReferencia = moment(new Date());

    var duration = moment.duration(dataReferencia.diff(data));

    var seconds = duration.asSeconds();

    if (this.profile.telefone_celular_verificado == 1) {
      this.isLoading = true;
      window.location.href = "/";
    }

    if (seconds < 60) {
      this.show_timeout = true;
      this.remaining_time = this.remaining_time - Math.round(seconds);
      this.showTimeOut();
    }

    this.celular_selecionado = this.profile.telefone_celular;
    this.formData.telefone_celular = this.profile.telefone_celular;

    if (!this.sent) {
      this.sendSMS();
    }
  },

  methods: {
    editarTelefone() {
      if (this.show_timeout) {
        this.showErrorMessage("Aguarde " + this.remaining_time + " segundos");
      } else {
        this.editar = true;
      }
    },

    async salvarTelefone() {
      const result = await this.v$.$validate();

      if (result) {
        this.celular_selecionado = this.formData.telefone_celular.replace(/[^Z0-9]/g, "");

        let data = {
          telefone_celular: this.celular_selecionado,
        };

        console.log(data);

        axios
          .post("/user/cadastro/update_celular", data)
          .then((response) => {
            console.log(response);

            if (!response.data.success) {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            } else {
              this.sent_date = new Date();
              this.show_timeout = true;

              this.remaining_time = 60;

              this.editar = false;

              this.showTimeOut();
              this.showSuccessMessage("Sms enviado");
            }
          })
          .catch((error) => {
            console.log("Error");
            console.log(error);
          });
      }
    },

    showTimeOut() {
      let that = this;

      setTimeout(function () {
        console.log("Tempo para enviar - " + that.remaining_time);
        if (that.remaining_time > 0) {
          that.remaining_time -= 1;
          that.showTimeOut();
        } else {
          that.show_timeout = false;
        }
      }, 1000);
    },

    async sendSMS() {
      const result = await this.v$.$validate();

      if (result) {
        axios
          .post("/new-verify/sms/send")
          .then((response) => {
            this.sent_date = new Date();
            this.show_timeout = true;

            this.remaining_time = 60;

            this.showTimeOut();
            this.showSuccessMessage("Sms enviado");
          })
          .catch((error) => {});
      }
    },

    validateCode() {
      let data = {
        codigo: this.codigo,
        telefone_celular: this.celular_selecionado,
      };

      axios
        .post("/new-verify/sms/code", data)
        .then((response) => {
          if (response.data.success) {
            window.location.href = "/user";
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
            this.codigo = "";
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
.my-append-text {
  border: solid 1px black;
  border-left: none;
}
</style>
